/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureSubscription extends models.ServiceAccountNativeDetailsBaseForAzureSubscription {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureSubscription>): ServiceAccountNativeDetailsForAzureSubscription {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureSubscription(), model);
        ServiceAccountNativeDetailsForAzureSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureSubscription>): ServiceAccountNativeDetailsForAzureSubscription {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureSubscription.newInstance(<ServiceAccountNativeDetailsForAzureSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureSubscription) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureSubscription): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureSubscription.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
